import React from "react";
import { useDispatch } from "react-redux";
import { updateQuantity } from "../../store/cartSlice";
import "../../style/common/number.scss";
import AddIcon from "../../icon/AddIcon";
import SubIcon from "../../icon/SubIcon";

const Number = ({ id, num, onChange }) => {
  const dispatch = useDispatch();
  const changeQuantity = (amount) => {
    if (onChange) {
      onChange(amount);
      return;
    }
    dispatch(updateQuantity({ id, quantity: amount }));
  };
  return (
    <React.Fragment>
      <div className="number">
        <div
          className="btn"
          role="button"
          tabIndex={0}
          aria-label="Decrease quantity"
          onClick={() => changeQuantity(-1)}
        >
          
          <SubIcon size={13} color="#000"/>
        </div>
        <div className="num">{num}</div>
        <div
          className="btn"
          role="button"
          tabIndex={0}
          aria-label="Increase quantity"
          onClick={() => changeQuantity(1)}
        >
          <AddIcon size={13} color="#000"/>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Number;
